/** @jsxImportSource @emotion/react */
import {
  Icon,
  createStyles,
  ListItem,
  useTheme,
  Copy,
} from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { BeneficiaryInformation } from '../api';

interface Props {
  info: BeneficiaryInformation;
}

export const BeneficiaryInfo = ({ info: beneficiaryInfo }: Props) => {
  const { formatMessage } = useIntl();
  const { spacing } = useTheme();
  const [showBeneficiaryInfo, setShowBeneficiaryInfo] = useState(false);
  const styles = useStyles();

  return (
    <div css={styles.container}>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
      {beneficiaryInfo && (
        <ListItem
          title={'Beneficiary information'}
          onClick={() => setShowBeneficiaryInfo(!showBeneficiaryInfo)}
          action={
            <div
              css={[
                styles.chevronContainer,
                showBeneficiaryInfo && { transform: 'rotate(90deg)' },
              ]}
            >
              <Icon name="chevron" size={spacing.xxs} />
            </div>
          }
        />
      )}
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
      {beneficiaryInfo && showBeneficiaryInfo && (
        <>
          <ListItem
            title={formatMessage({
              id: 'page.home.beneficiaryName',
            })}
            subtitle={beneficiaryInfo.merchantLegalName}
            action={<Copy textToCopy={beneficiaryInfo.merchantLegalName} />}
          />
          <ListItem
            title={formatMessage({
              id: 'page.home.quickbitVaspName',
            })}
            subtitle={beneficiaryInfo.vaspName}
            action={<Copy textToCopy={beneficiaryInfo.vaspName} />}
          />
          <ListItem
            title={formatMessage({
              id: 'page.home.quickbitVaspDid',
            })}
            subtitle={beneficiaryInfo.vaspDid}
            action={<Copy textToCopy={beneficiaryInfo.vaspDid} />}
          />
        </>
      )}
    </div>
  );
};

const useStyles = createStyles(({ palette, spacing, shape }) => ({
  container: {
    border: `1px solid ${palette.grey.x100}`,
    borderRadius: shape.borderRadius,
    width: '100%',
  },
  chevronContainer: {
    marginTop: spacing.xxxs,
    transform: 'rotate(-90deg)',
    svg: { fill: 'none', stroke: palette.black },
  },
}));
